// async (params) => {
//     document.addEventListener('DOMContentLoaded', () => {
//       console.log('🛡️ Ultimate Action Hijack Guard Engaged.');
    
//       const buttonSelector = '.add_to_cart.global-button.global-button--primary.ajax-submit.po-atc-btn';
    
//       document.addEventListener('click', (event) => {
//         const button = event.target.closest(buttonSelector);
        
//         if (button) {
//           const productForm = button.closest('form[action*="/cart/add"]');
//           let originalAction = '';
          
//           if (productForm) {
//             originalAction = productForm.getAttribute('action');
//             // Instantly break the form destination so no script can trigger a redirect
//             productForm.setAttribute('action', '#');
//             console.log('🔒 Form action safely neutralized.');
//           }
    
//           let intervalsFired = 0;
//           let errorDetected = false;
    
//           const structuralLoop = setInterval(() => {
//             intervalsFired++;
//             const errorElement = document.querySelector('.bss-error-msg');
    
//             if (errorElement) {
//               errorDetected = true;
              
//               // Force scroll back up to the missed option
//               const target = errorElement.closest('.po-option-wrapper') || 
//                              errorElement.closest('.product-form__input') || 
//                              errorElement;
                             
//               target.scrollIntoView({ 
//                 behavior: 'smooth', 
//                 block: 'center' 
//               });
//             }
    
//             // AFTER 350ms (7 intervals): Evaluate the outcome
//             if (intervalsFired >= 7) {
//               clearInterval(structuralLoop);
    
//               if (productForm) {
//                 // Restore the form action so future clean attempts or AJAX can work
//                 productForm.setAttribute('action', originalAction);
//                 console.log('🔓 Form action restored.');
//               }
    
//               if (!errorDetected) {
//                 console.log('🎉 Validation clean. Manually prompting theme mini-cart layout.');
                
//                 // Fire global theme events to tell your theme a product was added
//                 document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
//                 document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
                
//                 // Try to physically slide the theme drawer out if it hidden
//                 const cartDrawer = document.querySelector('.mini-cart, #CartDrawer, .drawer--right, [data-cart-drawer]');
//                 if (cartDrawer && typeof cartDrawer.classList.add === 'function') {
//                   cartDrawer.classList.add('active', 'is-open'); 
//                 }
//               }
//             }
//           }, 50);
//         }
//       }, true); // True guarantees we strip the action BEFORE BSS reads it
//     });
// }

document.addEventListener('DOMContentLoaded', () => {
  console.log('🛡️ Core Structural Guard Active.');

  const buttonSelector = '.add_to_cart.global-button.global-button--primary.ajax-submit.po-atc-btn';

  document.addEventListener('click', (event) => {
    const button = event.target.closest(buttonSelector);
    
    if (button) {
      const productForm = button.closest('form[action*="/cart/add"]');
      
      if (productForm) {
        console.log('🔒 Locking form structure to prevent page hopping...');
        
        // FORCE THE FORM TO SUBMIT INTO A HIDDEN BACKGROUND BLANK TARGET
        // This makes it physically impossible for the current page to redirect to /cart,
        // because any full-page submission is trapped in a hidden virtual window.
        productForm.setAttribute('target', 'hidden_cart_frame');
        
        // Create that hidden frame if it doesn't exist yet
        if (!document.getElementById('hidden_cart_frame')) {
          const frame = document.createElement('iframe');
          frame.id = 'hidden_cart_frame';
          frame.name = 'hidden_cart_frame';
          frame.style.display = 'none';
          document.body.appendChild(frame);
        }
      }

      let intervalsFired = 0;
      let errorDetected = false;

      const validationCheck = setInterval(() => {
        intervalsFired++;
        const errorElement = document.querySelector('.bss-error-msg');

        if (errorElement) {
          errorDetected = true;
          console.log('🚨 Option missing! Keeping page steady and scrolling up.');

          // Move the user up to the missing choice
          const target = errorElement.closest('.po-option-wrapper') || 
                         errorElement.closest('.product-form__input') || 
                         errorElement;
                         
          target.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center' 
          });
        }

        // AFTER 400ms: Evaluate if the submission was actually a clean success
        if (intervalsFired >= 8) {
          clearInterval(validationCheck);

          if (productForm) {
            // Clean up the form target for future attempts
            productForm.removeAttribute('target');
          }

          if (!errorDetected) {
            console.log('🎉 Clean submission detected! Animating your mini-cart drawer open.');
            
            // Tell your theme to refresh its cart contents natively
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));

            // Force your specific theme's drawer to slide open using your active_link class
            setTimeout(() => {
              const cartDrawer = document.querySelector('.mini-cart, #CartDrawer, .drawer--right, [data-cart-drawer]');
              if (cartDrawer) {
                cartDrawer.classList.add('active_link');
              }
            }, 100);
          }
        }
      }, 50);
    }
  }, true); // Captured at top priority level
});